import React from 'react';
import { Route, Redirect } from 'react-router-dom';

import AccessControl from './access-control';

import { getRedirectAfterSignInPath } from '../../tools';

import { userTypes } from '../../constants/user';

const ProtectedRoute = ({ rule, target, component, redirect, ...rest }) => (
  <Route {...rest} render={props => {
    if (!AccessControl.isReady()) {
      return component.loader
        ? component.loader()
        : null;
    }

    if (AccessControl.isAuthentificated()) {
      const [permission, accessScope] = rule.split(':').reverse();

      const mergedTarget = { 
        ...target, 
        ...props.match.params 
      };

      if (AccessControl.can(permission, accessScope, mergedTarget)) {
        return React.createElement(component, props);
      }
    }

    if (redirect) {
      const currentUserType = Object.keys(userTypes).find(userType => AccessControl.hasRole(userType));

      const redirectPath = getRedirectAfterSignInPath(userTypes[currentUserType]);

      const authenticatedRedirect = AccessControl.isAuthentificated() ? redirectPath : '/sign-in';

      const finalRedirect = typeof redirect === 'string' ? redirect : authenticatedRedirect;

      return (
        <Redirect push to={{
          pathname: finalRedirect,
          state: { from: props.location }
        }} />
      );
    }

    return null;
  }} />
);

export default ProtectedRoute;


// WEBPACK FOOTER //
// ./src/services/access-control/protected-route.js